import React from "react";
import { at } from "lodash";
import { useField } from "formik";
import {
    Radio,
    RadioGroup,
    FormControl,
    FormLabel,
    FormControlLabel,
    FormHelperText
} from "@material-ui/core";

const MRadioButton = (props) => {
    const { label, data, name, labelPlacement, disabled, ...rest } = props;
    const [field, meta] = useField(props);
    const [touched, error] = at(meta, "touched", "error");
    const isError = touched && error && true;

    const _renderHelperText = () => {
        if (isError) {
            return <FormHelperText>{error}</FormHelperText>;
        }
    };

    console.log({field})

    return (
        <>
            <FormControl component="fieldset" error={isError}>
                <FormLabel component="legend">{label}</FormLabel>
                <RadioGroup aria-label={name} row {...field} {...rest}>
                    {data.map((item) => (
                        <FormControlLabel
                            key={item.id}
                            value={item.id}
                            control={<Radio color="primary" />}
                            label={item.name}
                            labelPlacement={labelPlacement || "end"}
                            disabled={disabled || false}
                        />
                    ))}
                    {_renderHelperText()}
                </RadioGroup>
            </FormControl>
        </>
    );
};

MRadioButton.defaultProps = {
    label: null
};

export default MRadioButton;
